<template>
  <div class="assignment-actions-container">
    <div class="form-group">
      <b>Tipul comenzii</b>
      <v-select
        v-model="selectedCmd"
        :options="cmds"
        :disabled="announcement || verbalProcess ? true : false"
      >
      </v-select>
    </div>
    <div class="assignment-actions">
      <div
        v-if="selectedCmd && selectedCmd.value == 'catalog_seap'"
        class="form-group"
      >
        <b>Achiziție din catalogul S.E.A.P</b>
        <div>
          <div class="assignment-actions-btns">
            <button
              class="Button1 Btn_center"
              @click="openModal(AssignmentDocumentType.ComandaFermaTip2)"
            >
              <span class="Btn_content">CMD 1</span>
            </button>

            <button
              class="Button1 Btn_center"
              @click="openModal(AssignmentDocumentType.ComandaFermaArt31)"
            >
              <span class="Btn_content">CMD ART.31</span>
            </button>
          </div>
          <div class="assignment-actions-btns" style="margin-top: 5px">
            <button
              class="Button1 Btn_center"
              @click="openModal(AssignmentDocumentType.ContractTip2)"
            >
              <span class="Btn_content">CTR 1</span>
            </button>

            <button
              class="Button1 Btn_center"
              @click="openModal(AssignmentDocumentType.ContractArt31)"
            >
              <span class="Btn_content">CTR ART.31</span>
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="selectedCmd && selectedCmd.value == 'invitatie_participare'"
        class="form-group"
      >
        <b>Achiziție prin invitație de participare</b>
        <div v-if="!announcement" class="assignment-actions-btns">
          <button class="Button1 Btn_center" @click="createAnnouncement()">
            <span class="Btn_content">ANUNȚ</span>
          </button>
        </div>

        <div v-if="announcement">
          <div class="assignment-actions-btns">
            <button
              v-if="!paapCentralization.procedureType.socialOnly"
              class="Button1 Btn_center"
              @click="
                createAssignmentDocumentForAnnouncement(
                  AssignmentDocumentType.ComandaFermaTip4
                )
              "
            >
              <span class="Btn_content">CMD 2</span>
            </button>
            <button
              v-if="paapCentralization.procedureType.socialOnly"
              class="Button1 Btn_center"
              @click="
                createAssignmentDocumentForAnnouncement(
                  AssignmentDocumentType.ComandaFermaTipSocial
                )
              "
            >
              <span class="Btn_content">CMD SOCIALĂ</span>
            </button>
            <button
              v-if="!paapCentralization.procedureType.socialOnly"
              class="Button1 Btn_center"
              @click="
                createAssignmentDocumentForAnnouncement(
                  AssignmentDocumentType.ContractTip4
                )
              "
            >
              <span class="Btn_content">CTR 2</span>
            </button>

            <button
              v-if="paapCentralization.procedureType.socialOnly"
              class="Button1 Btn_center"
              @click="
                createAssignmentDocumentForAnnouncement(
                  AssignmentDocumentType.ContractTipSocial
                )
              "
            >
              <span class="Btn_content">CTR SOCIAL</span>
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="selectedCmd && selectedCmd.value == 'oferte'"
        class="form-group"
      >
        <b>Achiziție în baza ofertelor</b>
        <div v-if="!verbalProcess" class="assignment-actions-btns">
          <button
            class="Button1 Btn_center"
            @click="createVerbalProcess('verbal_process')"
          >
            <span class="Btn_content">PV</span>
          </button>
        </div>
        <div v-if="verbalProcess">
          <div class="assignment-actions-btns">
            <button
              @click="
                createAssignmentDocumentForVerbalProcess(
                  AssignmentDocumentType.ComandaFermaTip3
                )
              "
              class="Button1 Btn_center"
            >
              <span class="Btn_content">CMD 3</span>
            </button>

            <button
              @click="
                createAssignmentDocumentForVerbalProcess(
                  AssignmentDocumentType.ContractTip3
                )
              "
              class="Button1 Btn_center"
            >
              <span class="Btn_content">CTR 3</span>
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="selectedCmd && selectedCmd.value == 'angajament_legal'"
        class="form-group"
      >
        <b>Achizițieîn baza angajamentului legal</b>
        <div class="assignment-actions-btns">
          <button
            class="Button1 Btn_center"
            @click="openModal(AssignmentDocumentType.ComandaFermaTip1)"
          >
            <span class="Btn_content">CMD 4</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DialogModal from "@/components/DialogModal";
import Command1 from "@/components/Command1";
import VerbalProcess from "@/components/VerbalProcess";
import Announcement from "@/components/Announcement";
import { ASSIGNMENT_DOCUMENTS, VERBAL_PROCESS, ANNOUNCEMENT } from "../api.js";
import { OfferEvaluationResult } from "@/common/types/offer-evaluation-result.type";
import { AssignmentDocumentType } from "@/common/types/command.type.js";

export default {
  props: {
    parentTarget: { type: String, required: true },
    centralization: { type: Object, default: () => null },
    needReferences: { type: String | Array, default: () => null },
    verbalProcess: { type: Object, default: () => null },
    announcement: { type: Object, default: () => null },
  },

  data() {
    return {
      AssignmentDocumentType,
      selectedCmd: null,
      cmds: [],
    };
  },
  computed: {
    paapCentralization() {
      if (this.centralization) return this.centralization;
      if (this.announcement) return this.announcement.paapCentralization;
      if (this.verbalProcess) return this.verbalProcess.paapCentralization;
    },
  },

  methods: {
    openModal(type) {
      this.$modal.hide(this.parentTarget);

      this.$modal.show(
        DialogModal,
        {
          target: type,
          title: this.assignmentTitle[type],
          inputs: [
            {
              id: "cmd",
              type: "component",
              component: Command1,
              componentProps: {
                assignmentType: type,
                needReferences: this.needReferences,
              },
            },
          ],
          acceptFinish: (data) => {
            const cmd = data.cmd;
            if (cmd.assignmentDate) {
              const d = new Date(cmd.assignmentDate);
              d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
              cmd.assignmentDate = d.toISOString();
            }

            if (
              this.needReferences === "all" ||
              (Array.isArray(this.needReferences) &&
                this.needReferences.length > 0)
            ) {
              delete cmd.initialTotalValueWithoutTva;
              delete cmd.initialTotalValueWithTva;
            }

            if (cmd.filesConverting) {
              this.$toastr.w("Fișierele se convertesc în PDF...");
              return false;
            }
            delete cmd.filesConverting;

            if (
              type === AssignmentDocumentType.ComandaFermaTip1 &&
              (cmd.documents || []).filter((e) => !e.deleted).length === 0
            ) {
              this.$toastr.w("Nu a fost atașat nici un document justificativ.");
              return false;
            }

            for (const key in cmd) {
              if (!cmd[key]) {
                this.$toastr.w("Nu au fost completate toate secțiunile.");
                return false;
              }

              if (
                key === "departments" &&
                cmd[key].length === 0 &&
                Array.isArray(this.needReferences) &&
                this.needReferences.length === 0
              ) {
                this.$toastr.w("Nu a fost selectat nici un departament.");
                return false;
              }
            }
            return true;
          },
          closeBtnText: "Anulează",
          button: {
            type: 2,
            value: "Salvează",
            handler: (data) => {
              const error = (msg) => {
                this.$toastr.e(msg || "Salvarea achiziției a eșuat.");
                this.setLoad();
              };
              this.setLoad(true);
              ASSIGNMENT_DOCUMENTS.add({
                ...data.cmd,
                assignmentType: type,
                needReferences: Array.isArray(this.needReferences)
                  ? this.needReferences.map((el) => el.id)
                  : this.needReferences,
                paapCentralization: this.centralization,
              })
                .then(async (res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.setLoad();
                    this.$toastr.s("Achiziția a fost salvată.");

                    if (type === AssignmentDocumentType.ComandaFermaTip1) {
                      await this.addDocuments(res.data.id, data.cmd.documents);
                    }
                    const route = this.$route.path + "/achizitii";
                    this.$router.push({
                      path: route,
                      query: { aq: res.data.id },
                    });
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
          customClass: "full-dialog",
        },
        {
          name: type,
          adaptive: true,
          width: "900px",
          height: "800px",
        }
      );
    },

    async addDocuments(id, documents) {
      const sendData = new FormData();

      (documents || [])
        .filter((e) => !e.deleted && e.file instanceof File)
        .forEach((file) => {
          sendData.append("files", file.file);
        });

      const error = (msg) => {
        this.$toastr.e(
          msg || "Documentele justificative nu au fost încărcate."
        );
      };

      await ASSIGNMENT_DOCUMENTS.addDocuments(id, sendData)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            this.$toastr.s("Documentele justificative au fost încărcate.");
          } else {
            error(
              this.isObject(res?.response)
                ? res?.response?.message
                : res?.response
            );
          }
        })
        .catch((err) => error(err?.message));
    },

    createVerbalProcess(type) {
      this.$modal.hide(this.parentTarget);

      this.$modal.show(
        DialogModal,
        {
          target: type,
          title: "Proces verbal de evaluare al ofertelor",
          inputs: [
            {
              id: "pv",
              type: "component",
              component: VerbalProcess,
              errReason: "Nu au fost completate toate secțiunile.",
              componentProps: { needReferences: this.needReferences },
            },
          ],
          acceptFinish: (data) => {
            const pv = data.pv;

            if (
              this.needReferences === "all" ||
              (Array.isArray(this.needReferences) &&
                this.needReferences.length > 0)
            ) {
              delete pv.initialTotalValueWithoutTva;
              delete pv.initialTotalValueWithTva;
            }

            if (pv.verbalProcessDate) {
              const d = new Date(pv.verbalProcessDate);
              d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
              pv.verbalProcessDate = d.toISOString();
            }

            for (const key in pv) {
              if (key == "attributionCriteria") {
                if (!pv[key]) {
                  this.$toastr.w("Criteriul de atribuire nu este completat.");
                  return false;
                }
              }

              if (key == "requestModality") {
                if (!pv[key]) {
                  this.$toastr.w(
                    "Modalitatea de solicitare / obținere oferte financiare și tehnice nu este completata"
                  );
                  return false;
                }
              }

              if (key == "receiveModality") {
                if (!pv[key]) {
                  this.$toastr.w(
                    "Modalitatea de primire / obținere oferte financiare și tehnice nu este completată"
                  );
                  return false;
                }
              }

              if (key == "memberRole") {
                if (pv[key].length < 2) {
                  this.$toastr.w(
                    "Nu au fost selectați toti membrii reasponsabili pentru procedură."
                  );
                  return false;
                }

                for (let i = 0; i < pv[key].length; i++) {
                  if (!pv[key][i]) {
                    this.$toastr.w("Nu au fost completate toate secțiunile.");
                    return false;
                  }
                }
              }

              if (
                key === "departments" &&
                pv[key].length === 0 &&
                Array.isArray(this.needReferences) &&
                this.needReferences.length === 0
              ) {
                this.$toastr.w("Nu a fost selectat nici un departament.");
                return false;
              }

              if (key == "verbalProcessInstitutionProvider") {
                if (pv[key].length === 0) {
                  this.$toastr.w(`Trebuie să adaugați cel puțin un furnizor.`);
                  return false;
                }
                for (let i = 0; i < pv[key].length; i++) {
                  const item = pv[key][i];

                  if (!item.institutionProviderCui) {
                    this.$toastr.w(
                      `CUI-ul furnizorului din oferta ${
                        i + 1
                      } nu este completat.`
                    );
                    return false;
                  } else if (!item.totalValueWithoutTva) {
                    this.$toastr.w(
                      `Valoarea totală fără TVA din oferta ${
                        i + 1
                      } nu este completată.`
                    );
                    return false;
                  } else if (!item.tvaValue) {
                    this.$toastr.w(
                      `Valoarea cotei TVA din oferta ${
                        i + 1
                      } nu este completată.`
                    );
                    return false;
                  } else if (!item.totalValueWithTva) {
                    this.$toastr.w(
                      `Valoarea totală cu TVA din oferta ${
                        i + 1
                      } nu este completată.`
                    );
                    return false;
                  } else if (!item.institutionProviderName) {
                    this.$toastr.w(
                      `Numele furnizorului instituțional din oferta ${
                        i + 1
                      } nu este completat.`
                    );
                    return false;
                  } else if (item.annexes.length === 0) {
                    this.$toastr.w(
                      `Anexele din oferta ${i + 1} nu sunt completate.`
                    );
                    return false;
                  }
                }
              }
            }

            const offers = pv.verbalProcessInstitutionProvider || [];
            if (offers.some((o) => !o.evaluationResult)) {
              this.$toastr.w(
                "Rezultatul evaluării trebuie completat pentru toate ofertele."
              );
              return false;
            }
            const winners = offers.filter(
              (o) => o.evaluationResult === OfferEvaluationResult.WINNER
            ).length;
            const allNonCompliant = offers.every(
              (o) => o.evaluationResult === OfferEvaluationResult.NON_COMPLIANT
            );
            if (winners !== 1 && !allNonCompliant) {
              this.$toastr.w(
                "Trebuie să existe un ofertant câștigător, sau toți ofertanții să fie neconformi."
              );
              return false;
            }

            data.pv.memberRole = pv.memberRole.map((item) => ({
              id: item.id,
              role: item.role,
              user: {
                uuid: item.user.uuid,
                id: item.user.id,
                first_name: item.user.first_name,
                last_name: item.user.last_name,
              },
            }));

            return true;
          },
          closeBtnText: "Anulează",
          button: {
            type: 2,
            value: "Salvează",
            handler: (data) => {
              const error = (msg) => {
                this.$toastr.e(msg || "Salvarea procesului verbal a eșuat.");
                this.setLoad();
              };

              this.setLoad(true);

              VERBAL_PROCESS.add({
                ...data.pv,
                needReferences: Array.isArray(this.needReferences)
                  ? this.needReferences.map((el) => el.id)
                  : this.needReferences,
                paapCentralization: { id: this.centralization.id },
              })
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.setLoad();
                    this.$toastr.s("Procesul verbal a fost salvat.");
                    const route = this.$route.path + "/proces-verbal";
                    this.$router.push({
                      path: route,
                    });
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
          customClass: "verbal-process-modal",
        },
        {
          name: type,
          adaptive: true,
          width: "1000px",
          height: "1000px",
        }
      );
    },

    createAnnouncement() {
      this.$modal.hide(this.parentTarget);

      this.$modal.show(
        DialogModal,
        {
          target: "CreateAnnouncement",
          title: "Anunț",
          inputs: [
            {
              id: "announcement",
              type: "component",
              component: Announcement,
              errReason: "Nu au fost completate toate secțiunile.",
              componentProps: { needReferences: this.needReferences },
            },
          ],
          acceptFinish: (data) => {
            const announcement = data.announcement;

            if (
              this.needReferences === "all" ||
              (Array.isArray(this.needReferences) &&
                this.needReferences.length > 0)
            ) {
              delete announcement.initialTotalValueWithoutTva;
              delete announcement.initialTotalValueWithTva;
            }

            if (announcement.announcementDate) {
              const d = new Date(announcement.announcementDate);
              d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
              announcement.announcementDate = d.toISOString();
            }

            if (announcement.expireDate) {
              const d = new Date(announcement.expireDate);
              d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
              announcement.expireDate = d.toISOString();
            }

            for (const key in announcement) {
              if (!announcement[key]) {
                this.$toastr.w("Nu au fost completate toate secțiunile.");
                return false;
              }

              if (
                key === "departments" &&
                announcement[key].length === 0 &&
                Array.isArray(this.needReferences) &&
                this.needReferences.length === 0
              ) {
                this.$toastr.w("Nu a fost selectat nici un departament.");
                return false;
              }
            }

            return true;
          },

          closeBtnText: "Anulează",
          button: {
            type: 2,
            value: "Salvează",
            handler: (data) => {
              const error = (msg) => {
                this.$toastr.e(msg || "Salvarea anunțului a eșuat.");
                this.setLoad();
              };

              this.setLoad(true);
              ANNOUNCEMENT.add({
                ...data.announcement,
                needReferences: Array.isArray(this.needReferences)
                  ? this.needReferences.map((el) => el.id)
                  : this.needReferences,
                paapCentralization: this.centralization,
              })
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.setLoad();
                    this.$toastr.s("Anunțul a fost salvat.");
                    const route = this.$route.path + "/anunt";
                    this.$router.push({
                      path: route,
                    });
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
          customClass: "verbal-process-modal",
        },
        {
          name: "CreateAnnouncement",
          adaptive: true,
          width: "1000px",
          height: "650px",
        }
      );
    },

    createAssignmentDocumentForVerbalProcess(type) {
      this.$modal.hide(this.parentTarget);

      this.$modal.show(
        DialogModal,
        {
          target: "CreateAssignmentDocumentVerbalProduct",
          title: this.assignmentTitle[type],
          inputs: [
            {
              id: "cmd",
              type: "component",
              component: Command1,
              componentProps: {
                verbalProcess: this.verbalProcess,
                assignmentType: type,
                needReferences: this.needReferences,
              },
            },
          ],
          acceptFinish: (data) => {
            const cmd = data.cmd;

            if (
              this.needReferences === "all" ||
              (Array.isArray(this.needReferences) &&
                this.needReferences.length > 0) ||
              this.verbalProcess
            ) {
              delete cmd.initialTotalValueWithoutTva;
              delete cmd.initialTotalValueWithTva;
            }

            if (cmd.assignmentDate) {
              const d = new Date(cmd.assignmentDate);
              d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
              cmd.assignmentDate = d.toISOString();
            }

            delete cmd.filesConverting;

            for (const key in cmd) {
              if (!cmd[key]) {
                this.$toastr.w("Nu au fost completate toate secțiunile.");
                return false;
              }
            }
            return true;
          },
          closeBtnText: "Anulează",

          button: {
            type: 2,
            value: "Crează",
            handler: (data) => {
              const error = (msg) => {
                this.$toastr.e(msg || "Crearea a eșuat.");
                this.setLoad();
              };

              this.setLoad(true);
              VERBAL_PROCESS.createAssignmentDocument(this.verbalProcess.id, {
                ...data.cmd,
                assignmentType: type,
              })
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.setLoad();

                    this.$toastr.s("Crearea comenzii ferme a fost efectuată.");

                    const path = this.$route.path;
                    this.$router.push({
                      path: path.replace("proces-verbal", "achizitii"),
                      query: { aq: res.data.result.id },
                    });
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
          customClass: "full-dialog",
        },
        {
          name: "CreateAssignmentDocumentVerbalProduct",
          adaptive: true,
          width: "900px",
          height: "800px",
        }
      );
    },
    createAssignmentDocumentForAnnouncement(type) {
      this.$modal.hide(this.parentTarget);
      this.$modal.show(
        DialogModal,
        {
          target: "CreateAssignmentDocumentAnnouncement",
          title: this.assignmentTitle[type],
          inputs: [
            {
              id: "cmd",
              type: "component",
              component: Command1,
              componentProps: {
                announcement: this.announcement,
                assignmentType: type,
                needReferences: this.needReferences,
              },
            },
          ],
          acceptFinish: (data) => {
            const cmd = data.cmd;

            if (
              this.needReferences === "all" ||
              (Array.isArray(this.needReferences) &&
                this.needReferences.length > 0) ||
              this.announcement
            ) {
              delete cmd.initialTotalValueWithoutTva;
              delete cmd.initialTotalValueWithTva;
            }

            if (cmd.assignmentDate) {
              const d = new Date(cmd.assignmentDate);
              d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
              cmd.assignmentDate = d.toISOString();
            }

            delete cmd.filesConverting;

            for (const key in cmd) {
              if (!cmd[key]) {
                this.$toastr.w("Nu au fost completate toate secțiunile.");
                return false;
              }
            }
            return true;
          },
          closeBtnText: "Anulează",

          button: {
            type: 2,
            value: "Crează",
            handler: (data) => {
              const error = (msg) => {
                this.$toastr.e(msg || "Crearea a eșuat.");
                this.setLoad();
              };

              this.setLoad(true);
              ANNOUNCEMENT.createAssignmentDocument(this.announcement.id, {
                ...data.cmd,
                assignmentType: type,
              })
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Crearea comenzii ferme a fost efectuată.");
                    const path = this.$route.path;
                    this.$router.push({
                      path: path.replace("anunt", "achizitii"),
                      query: { aq: res.data.result.id },
                    });
                    this.setLoad();
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
          customClass: "full-dialog",
        },
        {
          name: "CreateAssignmentDocumentAnnouncement",
          adaptive: true,
          width: "900px",
          height: "800px",
        }
      );
    },
  },

  created() {
    if (this.centralization && !this.centralization.procedureType.socialOnly) {
      this.cmds.push(
        { value: "catalog_seap", label: "Achiziție din catalogul S.E.A.P" },
        { value: "oferte", label: "Achiziție în baza ofertelor" },
        {
          value: "invitatie_participare",
          label: "Achiziție prin invitație de participare",
        },
        {
          value: "angajament_legal",
          label: "Achiziție în baza angajamentului legal",
        }
      );
    } else if (this.centralization) {
      this.cmds.push({
        value: "invitatie_participare",
        label: "Achiziție prin invitație de participare",
      });
      this.selectedCmd = {
        value: "invitatie_participare",
        label: "Achiziție prin invitație de participare",
      };
    }

    if (this.verbalProcess) {
      this.selectedCmd = {
        value: "oferte",
        label: "Achiziție în baza ofertelor",
      };
    } else if (this.announcement) {
      this.selectedCmd = {
        value: "invitatie_participare",
        label: "Achiziție prin invitație de participare",
      };
    }
  },
};
</script>
<style lang="scss">
.assignment-actions-container {
  max-width: 900px;

  .assignment-actions {
    flex: 1;
    .Button1 {
      border: 0;
      margin: 3px;
    }
    &-btns {
      border: 1px solid;
      border-radius: 5px;
      padding: 10px;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
    }
  }
  .assignment-actions-info_container {
    flex: 0.5;
    .assignment-actions-info {
      border: 1px solid;
      border-radius: 5px;
      width: 100%;
      height: 100%;
      padding: 10px;
    }
  }
}
.verbal-process-modal {
  max-width: 100% !important;
  max-height: 100% !important;
}
</style>
